import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-checkbox-group-texts',
  templateUrl: './checkbox-group-texts.component.html',
  styleUrl: './checkbox-group-texts.component.scss'
})
export class CheckboxGroupTextsComponent {
  @Input() textKey!: string;
}
